export default "__VITE_ASSET__BXmJTXR5__"